<div class="adjust-tab">

  <div class="field date-chips">
    <div class="label">{{ this.expirationLabel }}</div>
    <div class="chips">
      <!-- CR-20260831-004: .param-changed on the SELECTED chip = the run addressed another
           expiration than the one now chosen. -->
      <div class="chip"
           *ngFor="let d of this.dateItems"
           [class.selected]="this.isDateSelected(d.value)"
           [class.param-changed]="this.isDateSelected(d.value) && this.isChanged('expiration')"
           (click)="this.selectDate(d.value)">
        {{ d.label }}
      </div>
      <div class="empty" *ngIf="this.dateItems.length === 0">No Expirations in the Book.</div>
    </div>
    <div class="hint" *ngIf="this.dateItems.length > 1 && !this.hasSelectedDate">Choose an Expiration to Run.</div>
  </div>

  <!-- `allowClosedBlockEngine` was passed here and is gone (2026-08-08): the engine has one composer,
       so there is nothing for the Adjust tab to switch between. See hg-copilot-risk-inputs. -->
  <ets-hg-copilot-risk-inputs [allowFillGap]="true" [allowHarvest]="true" [allowAllLevels]="true" [allowExpectedRange]="true" [targetInstrument]="this.targetInstrument" [expiration]="this.strikeExpiration" [changedKeys]="this.changedKeys" [defaultQty]="this.defaultQty" (stateChange)="this.onRiskChange($event)"></ets-hg-copilot-risk-inputs>
</div>
